<div class="project-opening-times">
  <div class="project-opening-times__content">
    <form class="opening-times" [formGroup]="form">
      <div class="opening-times__head">
        <div class="opening-times__title mat-titlemedium">
          {{ "Projektöffnungszeiten" | translate: "label-project-opening-times" }}
        </div>
        <p class="opening-times__description mat-body-medium">
          {{
          "Regelöffnungszeiten bedingen die Zutrittsberechtigung zur Baustelle.{0}Alle Wochentage müssen mit Uhrzeit definiert werden."
              | translate: "label-opening-times-description" | template : [ "\n" ] : true
          }}
        </p>
      </div>

      @for (group of groupsFa.controls; let i = $index; track i) {
        <div class="opening-times__group">
          <app-opening-times-days
            [days]="days"
            [dayStatuses]="daysCtrl(i).value"
            [isDayDisabledFn]="getDayDisabledFn(i)"
            (dayToggle)="toggleDay(i, $event)"
          />

          <div class="opening-times__ranges">
            @for (r of rangesFa(i).controls; let rIdx = $index; track rIdx) {
              <div class="opening-times__range-line" [formGroup]="rangeAt(i, rIdx)">

                <div class="opening-times__input-wrapper">
                  <div class="opening-times__input-fields">
                    <mat-form-field appearance="outline" matAutocompleteOrigin #formFieldFrom="matAutocompleteOrigin">
                      <mat-label>{{ "Von" | translate :  "label-opening-times-range-input-from" }}</mat-label>
                      <app-time-input
                        [formControl]="getControl(i, rIdx, 'from')"
                        placeholder="HH:MM"
                        [options]="hours"
                        [isOptionDisabled]="getOptionDisableFn(i, rIdx, true)"
                        [optionTooltip]="getOptionTooltipFn(i, rIdx, true)"
                        [connectedFormField]="formFieldFrom"
                      />
                    </mat-form-field>

                    <mat-form-field appearance="outline" matAutocompleteOrigin #formFieldUntil="matAutocompleteOrigin">
                      <mat-label>{{ "Bis" | translate :  "label-opening-times-range-input-to" }}</mat-label>
                      <app-time-input
                        [formControl]="getControl(i, rIdx, 'to')"
                        placeholder="HH:MM"
                        [options]="hours"
                        [isOptionDisabled]="getOptionDisableFn(i, rIdx, false)"
                        [optionTooltip]="getOptionTooltipFn(i, rIdx, false)"
                        [connectedFormField]="formFieldUntil"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <!-- TODO: kann wieder rein wenn neues backend da ist
                  <span class="opening-times__range-actions">
                    @if (rIdx > 0) {
                      <button mat-icon-button type="button"
                              (click)="removeRange(i, rIdx)"
                              [disabled]="group.get('allDayOpen')?.value || isGroupAllClosed(i)"
                              aria-label="Zeitfenster löschen">
                        <ogs-m3-icon prefix="fal" icon="trash" />
                      </button>

                    <button mat-icon-button type="button"
                            (click)="addRange(i)"
                            [disabled]="group.get('allDayOpen')?.value || isGroupAllClosed(i) || canAddRange(i)"
                            aria-label="Zeitfenster hinzufügen">
                      <ogs-m3-icon prefix="fal" icon="add" />
                    </button>
                  </span> }-->
              </div>
            }
          </div>

          <div class="opening-times__allday">
            <span class="mat-body-medium">
              {{ "oder" | translate: "label-or" }}
            </span>
            <mat-checkbox
              labelPosition="before"
              [checked]="groupAt(i).get('allDayOpen')?.value"
              (change)="toggleAllDay(i)"
              class="opening-times__checkbox-always-open mat-body-medium">
              {{ "Durchgehend(24 Std.) geöffnet" | translate: "action-all-day" }}
            </mat-checkbox>
          </div>

          <div class="opening-times__trash">
            <button mat-icon-button type="button"
                    (click)="removeGroup(i)"
                    [disabled]="groupsFa.length === 1"
                    aria-label="Gruppe löschen">
              <ogs-m3-icon prefix="fal" icon="trash" />
            </button>
          </div>
        </div>
      }

      <button
        type="button"
        mat-button
        class="opening-times__add-group"
        (click)="addGroup()"
        [disabled]="canAddRange(groupsFa.controls.length - 1)">
        <span class="ot-btn-content">
          <ogs-m3-icon prefix="fal" icon="add" />
          <span class="ot-btn-text">
            {{ "Zeitfenster hinzufügen" | translate: "action-add-time-range" }}
          </span>
        </span>
      </button>

      <div class="opening-times__legend">
        <app-legend
          class="opening-times__legend"
          [items]="legendItems"
        />
      </div>

      <mat-divider class="opening-times__divider divider-outline-variant" />
    </form>
  </div>
  <app-form-footer
    (save)="saveChanges()"
    (discard)="discardChanges()"
  />
</div>
